import getHeaderH from './getHeaderH';
import scrollTo from './scrollTo';

/**
 * スムーススクロール
 * @param {boolean} headerisFixed - ヘッダーが追従するかどうか（移動位置の計算に使用）
 */
const smoothScroll = (headerisFixed = true) => {
    const doWhenLoaded = () => {
        // すべてのhref="#"のaタグを取得
        const tariggerList = document.querySelectorAll('a[href^="#"]');
        if (!tariggerList.length) return;

        // ヘッダーの高さを取得
        const headerH = headerisFixed ? getHeaderH() : 0; //追従なしの場合は0
    
        for (let i = 0; i < tariggerList.length; i++) {
            const trigger = tariggerList[i];

            // aタグにそれぞれクリックイベントを設定
            trigger.addEventListener('click', (e) => {
    
                // ターゲットの位置を取得
                e.preventDefault();
                const href = trigger.getAttribute('href'); // 各a要素のリンク先を取得
                const target = document.getElementById(href.replace('#', '')); // リンク先の要素（コンテンツ）を取得
                let pos = 0; //初期値0(ターゲットが存在しない場合はTOPに移動)
                
                if (target) {
                    const offset = target.getBoundingClientRect().top; // ブラウザからの高さを取得
                    pos = offset + window.scrollY - headerH; //最終的な位置（要素の位置 + 現在のスクロール量 - ヘッダーの高さ）
                }
    
                // スクロールを実行
                scrollTo(pos);
            });
        }
    }
    window.addEventListener('load', doWhenLoaded);
    window.addEventListener('resize', doWhenLoaded);
}

export default smoothScroll